/* eslint-disable prefer-rest-params */
/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
import DateMoment from './date-moment';

export default {

  install(Vue) {
    Vue.prototype.$date = Vue.$date = function date(...args) {
      const key = args[0];
      if (typeof DateMoment[key] === 'function') {
        return DateMoment[key].call(DateMoment, ...args.slice(1));
      }
      throw new Error(`Unkown $date key ${key} in DateMoment (got undefined)`);
    };

    Vue.filter('date', DateMoment.format);
    Vue.filter('datetime', DateMoment.formatTime);
  },

};
